"use strict";
//
// Copyright © 2020, 2021 Anticrm Platform Contributors.
// Copyright © 2026 Intabia Fusion.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNAUTHORIZED = exports.ERROR = exports.OK = exports.PlatformError = exports.Status = exports.Severity = void 0;
exports.isPlatformPropagateError = isPlatformPropagateError;
exports.isInfoError = isInfoError;
exports.isOkError = isOkError;
exports.unknownStatus = unknownStatus;
exports.unknownError = unknownError;
const platform_1 = __importDefault(require("./platform"));
/**
 * Status severity
 * @public
 */
var Severity;
(function (Severity) {
    Severity["OK"] = "OK";
    Severity["INFO"] = "INFO";
    Severity["WARNING"] = "WARNING";
    Severity["ERROR"] = "ERROR";
})(Severity || (exports.Severity = Severity = {}));
/**
 * Status of an operation
 * @public
 */
class Status {
    severity;
    code;
    params;
    notLocalizedParams;
    options;
    constructor(severity, code, params, notLocalizedParams, options) {
        this.severity = severity;
        this.code = code;
        this.params = params;
        this.notLocalizedParams = notLocalizedParams;
        this.options = options;
    }
}
exports.Status = Status;
/**
 * Error object wrapping `Status`
 * @public
 */
class PlatformError extends Error {
    status;
    constructor(status) {
        super(`${status.severity}: ${status.code} ${JSON.stringify(status.params)}`);
        this.status = status;
    }
    get propagate() {
        return this.status.options?.propagate === true;
    }
    get timeout() {
        return this.status.options?.timeout;
    }
}
exports.PlatformError = PlatformError;
/**
 * Helper to check if a platform error should be propagated to client callers
 * @public
 */
function isPlatformPropagateError(err) {
    return err instanceof PlatformError && err.status?.options?.propagate === true;
}
function isInfoError(err) {
    return err instanceof PlatformError && err.status?.severity === Severity.INFO;
}
function isOkError(err) {
    return err instanceof PlatformError && err.status?.severity === Severity.OK;
}
/**
 * OK Status
 * @public
 */
exports.OK = new Status(Severity.OK, platform_1.default.status.OK, {});
/**
 * Error Status
 * @public
 */
exports.ERROR = new Status(Severity.ERROR, platform_1.default.status.BadError, {});
/**
 * Error Status for Unauthorized
 * @public
 */
exports.UNAUTHORIZED = new Status(Severity.ERROR, platform_1.default.status.Unauthorized, {});
/**
 * @public
 * @param message -
 * @returns
 */
function unknownStatus(message, extra) {
    return new Status(Severity.ERROR, platform_1.default.status.UnknownError, { message, ...(extra ?? {}) });
}
/**
 * Creates unknown error status
 * @public
 */
function unknownError(err, extra) {
    if (err instanceof PlatformError)
        return err.status;
    if (err instanceof Error)
        return unknownStatus(err.message, extra);
    if (typeof err === 'string')
        return unknownStatus(err, extra);
    return exports.ERROR;
}
//# sourceMappingURL=status.js.map